// extracted by mini-css-extract-plugin
export default {"facilityName":"cA9tXGvo"};